import { __awaiter } from "tslib";
import IPFSStorageAdapter from "./IPFSStorageAdapter";
import LocalStorageAdapter from "./LocalStorageAdapter";
class CachedIPFSStorageAdapter {
    constructor(ipfsClient = new IPFSStorageAdapter(), cache = new LocalStorageAdapter()) {
        this.ipfsClient = ipfsClient;
        this.cache = cache;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ipfsClient.init();
            yield this.cache.init();
        });
    }
    set(contentId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            const newContentId = yield this.ipfsClient.set(contentId, content);
            /**
             * updating data on ipfs creates a new content id, and the previous content id is no longer used.
             * The previous item is being removed from the cache as it is no longer needed
             */
            yield this.cache.remove(contentId);
            yield this.cache.set(newContentId, content);
            return newContentId;
        });
    }
    getNewAndCache(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.ipfsClient.get(contentId);
            if (result) {
                this.cache.set(contentId, result);
            }
            return result;
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const cachedResult = yield this.cache.get(contentId);
            const result = cachedResult || this.getNewAndCache(contentId);
            return result;
        });
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const hasCached = this.cache.has(contentId);
            return hasCached || this.ipfsClient.has(contentId);
        });
    }
}
export default CachedIPFSStorageAdapter;
